<template>
  <div id="app">
    <navigation/>
    <div class="px-3">
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
export default {
  name: 'App',
  components: {
    Navigation
  }
}
</script>

<style lang="scss">
  @import './assets/styles/bootstrap-with-overridings.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  .hidden {
    display: none;
  }

  /* Fix modal backdrop styling */
  .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.5) !important;
    opacity: 1 !important;
    z-index: 1040 !important;
  }

  .modal-backdrop.show {
    opacity: 1 !important;
  }

  .modal {
    z-index: 1050 !important;
  }

  /* Ensure modal content is properly styled */
  .modal-content {
    border: none !important;
    border-radius: 0.3rem !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
</style>
